<template>
  <div>
    <p>Selected Employee Name: {{ getEmployeeName(activeUser) }}</p>
  </div>
</template>

<script>
export default {
  props: {
    activeUser: {
      type: Number,
      required: true,
    },
    getEmployeeName: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
